<template>
  <SmartRow
    class="px-4 flex align-center justify-between relative">
    <SmartInput
      v-model="question.title"
      label="Título da pergunta"
      placeholder="Escreva o título aqui"
      class="lg:col-6 my-1 sm:col-12"
      @change="setSectionValueWhenEmpty"
    />
    <VSelect
      v-show="question.id === currentSelection"
      v-model="question.type"
      :items="questionTypes"
      item-text="label"
      item-value="id"
      class="lg:col-5 md:col-6 sm:col-12"
      @change="changeQuestionType(question)">
      <template
        slot="item"
        slot-scope="{ item }">
        <SmartIcon
          :size="2"
          :name="item.icon"
          class="mr-1 font-opacity-hg"
        />
        <span class="font-opacity-hg inline-block mr-1-4">
          {{ item.label }}
        </span>
      </template>
      <template
        slot="selection"
        slot-scope="{ item }">
        <SmartIcon
          :size="2"
          :name="item.icon"
          class="mr-1 font-opacity-md"
        />
        <span class="font-opacity-md inline-block mr-1-4">
          {{ item.label }}
        </span>
      </template>
    </VSelect>
    <div
      v-show="question.id !== currentSelection"
      class="inline-flex align-center font-opacity-md">
      <SmartIcon
        :size="2"
        :name="currentQuestionType.icon"
        class="mr-1"
      />
      {{ currentQuestionType.label }}
    </div>
  </SmartRow>
</template>

<script>
// @flow
import { questionTypes, INPUT, PICTURE } from '../../utils';
import { createOption } from '../../functions';

export default {
  props: {
    question: {
      type: Object,
      required: true
    },
    questionIndex: {
      type: Number,
      default: -1
    },
    currentSelection: {
      type: Number,
      default: -1
    }
  },
  data: () => ({
    questionTypes
  }),
  computed: {
    currentQuestionType() {
      return questionTypes.find(question => this.question.type === question.id) || {};
    }
  },
  methods: {
    changeQuestionType(question: SmartQuestion) {
      if (question.type === INPUT || question.type === PICTURE) {
        question.hasOtherOption = false;
        question.options = [];
      } else if (!question.options.length) {
        question.options = [createOption()];
      }
    },
    setSectionValueWhenEmpty() {
      if (this.question.title) { return; }
      this.question.title = `Pergunta ${this.questionIndex + 1}`;
    }
  }
};
</script>
